"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Dragger = _interopRequireDefault(require("./Dragger"));

var _Badge = _interopRequireDefault(require("./Badge"));

var _Hide = _interopRequireDefault(require("./Hide"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _IconLoading = _interopRequireDefault(require("./IconLoading"));

var ENUM = _interopRequireWildcard(require("./enum"));

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _Close = _interopRequireDefault(require("./Close"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    background-color: rgb(21, 59, 210);\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var editTextStyle = {
  fontSize: '12px',
  color: 'rgba(255,255,255,.85)',
  lineHeight: '20px',
  margin: 0,
  marginLeft: 1,
  textAlign: 'center'
};
var BubbleWrapper = (0, _styledComponents.default)('div')(_templateObject());

var Bubble = /*#__PURE__*/function (_React$Component) {
  _inherits(Bubble, _React$Component);

  var _super = _createSuper(Bubble);

  function Bubble(props) {
    var _this;

    _classCallCheck(this, Bubble);

    _this = _super.call(this, props);

    _this.hideBubble = function () {
      _this.setState({
        hide: true
      }, function () {
        window.localStorage.setItem(ENUM.STORE_BUBBLE_HIDE, 'true');
      });
    };

    _this.showBubble = function (e) {
      // 显示 bubble 时取消页面的编辑模式
      window.postMessage(JSON.stringify({
        action: 'umi.ui.disableBlockEditMode'
      }), '*');
      var _this$props = _this.props,
          toggleMiniOpen = _this$props.toggleMiniOpen,
          resetEdit = _this$props.resetEdit,
          edit = _this$props.edit;

      if (edit) {
        resetEdit();
        return false;
      }

      if (_this.state.hide) {
        // isHide
        _this.setState({
          hide: false
        }, function () {
          window.localStorage.removeItem(ENUM.STORE_BUBBLE_HIDE);
        });
      } else if (e.target === _this.nodeDom) {
        // not hide, show iframe
        toggleMiniOpen();
      }
    };

    var hide = window.localStorage.getItem(ENUM.STORE_BUBBLE_HIDE) === 'true';
    _this.state = {
      hide: hide
    };
    return _this;
  }

  _createClass(Bubble, [{
    key: "componentDidMount",

    /**
     * 初始化dom
     */
    value: function componentDidMount() {
      // eslint-disable-next-line
      this.nodeDom = _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    // handleDrag = () => {
    //   if (this.props.open) {
    //     this.props.toggleMiniOpen(false);
    //   }
    // };
    value: function render() {
      var _this$props2 = this.props,
          isBigfish = _this$props2.isBigfish,
          open = _this$props2.open,
          loading = _this$props2.loading,
          notice = _this$props2.notice,
          children = _this$props2.children,
          message = _this$props2.message,
          locale = _this$props2.locale,
          edit = _this$props2.edit,
          editText = _this$props2.editText;
      var hide = this.state.hide;
      var Logo = (0, _Logo.default)({
        isBigfish: isBigfish
      });
      var bubbleWrapperStyle = {
        backgroundColor: open ? '#30303D' : '#4c4c61',
        height: 60,
        width: 60,
        pointerEvents: 'none',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        userSelect: 'none',
        borderRadius: '50%',
        boxShadow: '0 4px 8px 0 rgba(13, 26, 38, 0.2)',
        padding: 16,
        transition: 'background-color 0.2s ease 0.1s opacity 0.2s ease 0s, transform 0.2s ease 0.1s'
      };
      var closeStyle = {
        position: 'absolute',
        top: '50%',
        userSelect: 'none',
        color: '#fff',
        transform: open ? 'translateY(-50%)' : 'translateY(-50%) scale(0.4) rotate(-45deg)',
        opacity: open ? 1 : 0,
        transition: 'all 0.3s linear',
        width: 20,
        height: 20
      };
      return /*#__PURE__*/_react.default.createElement(_Dragger.default, {
        open: open,
        hide: hide,
        onClick: this.showBubble,
        onOverlap: this.hideBubble,
        message: message // onDrag={this.handleDrag}
        ,
        isBigfish: isBigfish,
        locale: locale
      }, !edit && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        isBigfish: isBigfish,
        message: message
      }), /*#__PURE__*/_react.default.createElement(BubbleWrapper, {
        style: bubbleWrapperStyle,
        open: open
      }, loading && /*#__PURE__*/_react.default.createElement(_IconLoading.default, null), notice && /*#__PURE__*/_react.default.createElement(_Badge.default, null), edit ? /*#__PURE__*/_react.default.createElement("p", {
        style: editTextStyle
      }, editText[locale] || editText['zh-CN'] || '') : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Logo, {
        style: {
          width: 28,
          height: 28
        },
        open: open
      }), /*#__PURE__*/_react.default.createElement(_Close.default, {
        style: closeStyle
      }))), !edit && !open && /*#__PURE__*/_react.default.createElement(_Hide.default, {
        onClick: this.hideBubble
      }), children);
    }
  }]);

  return Bubble;
}(_react.default.Component);

var _default = Bubble;
exports.default = _default;